import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KxLoggingService {
	log(message: string) {
		console.log(message);		
	}
}
